import { render } from "./SendMail.vue?vue&type=template&id=7ad50d45&scoped=true"
import script from "./SendMail.vue?vue&type=script&lang=js"
export * from "./SendMail.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./SendMail.vue?vue&type=style&index=1&id=7ad50d45&scoped=true&lang=css"

import exportComponent from "/home/projects/frontend.vendor-mailing-system.pravin/vendor-mailig-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad50d45"]])

export default __exports__